import { numeral } from '@fund/basic-lib';
import { scale as config } from '../config';
import p from './public';

numeral.cash([
  {
    amount: 10000,
    unit: '万',
    isLock: false, // 如果希望10000以下都有万单位，设置isLock:true
  },
  {
    amount: 1000000,
    unit: '百万',
  },
  {
    amount: 100000000,
    unit: '亿',
  },
]);

// 基金规模（柱状图）
export default {

  // 格式化数据
  formatData: (row, ESTABDATE) => {
    const data = [];

    // eslint-disable-next-line array-callback-return
    row.Datas.slice(0, 4).map((d) => {
      data.splice(0, 0, {
        nav: d.NETNAV - 0,
        date: d.FSRQ.substring(2),
      });
    });
    console.log(ESTABDATE);
    // 如果没满4个（补齐）
    // 第一个显示成立日 其他空着
    if (data.length < 4 && data.length > 0) {
      // data[0].date = `${ESTABDATE.substring(2)}成立`;
    }
    // let index = 0;
    // while (data.length < 4) {
    //   data.splice(index, 0, {
    //     nav: 0,
    //     date: index === 0 ? `${ESTABDATE.substring(2)}成立` : `fake_${index}`,
    //   });
    //   index += 1;
    // }
    data.forEach((obj) => {
      // eslint-disable-next-line no-param-reassign
      obj.sizeType = 1;
    });
    return data;
  },

  // 绘制走势图
  drawChart(data, chart) {
    console.log(data);
    console.log('drawChart data');
    // 绘制
    chart.source(data);

    chart.legend(false);
    chart.axis('nav', false);
    chart.tooltip(false);

    chart.axis('date', {
      ...p().xAxisGridConfig,
      ...p().xAxisConfig,
      label: function label(text) {
        let textCfg = null;
        if (!/fake/.test(text)) {
          textCfg = {
            text,
            fontSize: 13,
          };
        }
        return textCfg && { ...p().xAxisConfig, ...textCfg };
      },
    });
    let count = 0;
    if (data) {
      if (data.length <= 4) {
        count = data.length;
      }
    }
    chart.interval()
      .position('date*nav')
      .color('date', config.colorsGM[count])
      .size('sizeType', [30, 100]);
    // .animate(false);

    // 水印
    p().drawLogo(chart, -window.innerWidth * 0.02, ['max', 'min']);

    chart.render();

    // 绘制柱状图文本
    const offset = -5;
    const canvas = chart.get('canvas');
    const group = canvas.addGroup();
    const shapes = {};
    data.forEach((obj) => {
      if (!obj.nav) return;
      const point = chart.getPosition(obj);
      let gm = '--';
      if (obj.nav) {
        if (obj.nav >= 1000000) {
          const scaleAllMoneys = obj.nav / 100000000;
          const tt = scaleAllMoneys.toFixed(2);
          gm = `${tt}亿`;
        } else if (obj.nav >= 100) {
          const scaleAllMoneys = obj.nav / 10000;
          const tt = scaleAllMoneys.toFixed(2);
          gm = `${tt}万`;
        } else {
          const scaleAllMoneys = obj.nav;
          const tt = scaleAllMoneys.toFixed(2);
          gm = `${tt}`;
        }
      }
      const text = group.addShape('text', {
        attrs: {
          ...p().xAxisConfig,
          x: point.x,
          y: point.y + offset,
          text: gm,
          textAlign: 'center',
          textBaseline: 'bottom',
          fill: '#000',
          fontSize: 15,
        },
      });

      shapes[obj.date] = text; // 缓存该 shape, 便于后续查找
    });
  },
};
